import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Circle from '../Circle/Circle'

class CirclesContainer extends PureComponent{
  constructor(props) {
    super(props);

    this.mediaCircles = [
      {
        diameter: 28,
        top: "-7%",
        left: "5%",
        float: "down",
        rotate: "left",
        max: 400,
        min: 107
      },
      {
        diameter: 47,
        top: "28%",
        left: "66%",
        float: "down",
        rotate: "right",
        max: 680,
        min: 142
      },
      {
        diameter: 12,
        top: "8%",
        left: "60%",
        float: "down",
        rotate: "right",
        max: 180,
        min: 56
      },
      {
        diameter: 17,
        top: "45%",
        left: "30%",
        float: "down",
        rotate: "right",
        max: 240,
        min: 56
      },
      {
        diameter: 47,
        top: "75%",
        left: "-7%",
        float: "down",
        rotate: "right",
        max: 680,
        min: 142
      },
    ];
    this.bigScreenMediaCircles = [
      {
        diameter: 28,
        top: "-7%",
        left: "-7%",
        float: "down",
        rotate: "left",
        max: 1000,
        min: 107
      },
      {
        diameter: 47,
        top: "28%",
        left: "66%",
        float: "down",
        rotate: "right",
        max: 1680,
        min: 142
      },
      {
        diameter: 12,
        top: "8%",
        left: "60%",
        float: "down",
        rotate: "right",
        max: 1180,
        min: 56
      },
      {
        diameter: 17,
        top: "45%",
        left: "30%",
        float: "down",
        rotate: "right",
        max: 1240,
        min: 56
      },
      {
        diameter: 47,
        top: "75%",
        left: "-7%",
        float: "down",
        rotate: "right",
        max: 1680,
        min: 142
      },
    ];

    this.mobileMediaCircles = [
      {
        diameter: 28,
        top: "10%",
        left: "-15%",
        float: "down",
        rotate: "left",
        max: 400,
        min: 150
      },
      {
        diameter: 47,
        top: "44%",
        left: "56%",
        float: "down",
        rotate: "right",
        max: 680,
        min: 400
      },
      {
        diameter: 12,
        top: "8%",
        left: "60%",
        float: "down",
        rotate: "right",
        max: 180,
        min: 56
      },
      {
        diameter: 17,
        top: "50%",
        left: "20%",
        float: "down",
        rotate: "right",
        max: 240,
        min: 56
      },
      {
        diameter: 47,
        top: "85%",
        left: "17%",
        float: "down",
        rotate: "right",
        max: 680,
        min: 142
      },
    ];

    this.currentScreenSize = typeof window !== "undefined" && window.innerWidth;
  }
  
  render(){
    return (
      <div
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          bottom: 0,
          right: '0',
          zIndex: 1,
        }}
      >
      {this.currentScreenSize > 768 ?
        (this.currentScreenSize > 2000 ?
        this.bigScreenMediaCircles.map((m, index) => (
          <Circle
            key={index}
            diameter={m.diameter}
            top={m.top}
            left={m.left}
            float={m.float}
            rotate={m.rotate}
            max={m.max}
            min={m.min}
          />
        ))
        :
        this.mediaCircles.map((m, index) => (
          <Circle
            key={index}
            diameter={m.diameter}
            top={m.top}
            left={m.left}
            float={m.float}
            rotate={m.rotate}
            max={m.max}
            min={m.min}
          />
        ))
        )
        :
        this.mobileMediaCircles.map((m, index) => (
          <Circle
            mobile
            key={index}
            diameter={m.diameter}
            top={m.top}
            left={m.left}
            float={m.float}
            rotate={m.rotate}
            max={m.max}
            min={m.min}
          />
        ))
      }
      </div>
    );
  }
}

CirclesContainer.defaultProps = {
  media: [],
  parentHeight: 0,
  parentWidth: 0,
  url: []
};

CirclesContainer.propTypes = {
  media: PropTypes.array,
  parentHeight: PropTypes.node,
  parentWidth: PropTypes.node,
  url: PropTypes.array
};

export default CirclesContainer;
